import React, { useContext } from "react";
import { StateContext } from "../../../state";
import LoadingPage from "../../library/LoadingPage";
import { isReturningFromOauth } from "../../../utils/oauth";

export const BaseView = () => {
  const [{configuration}] = useContext(StateContext);

  return <LoadingPage {...(configuration.validatePayment[isReturningFromOauth() ? 'returningFromOauth' : 'initialVisit'])} />
};

export default BaseView;
